import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'

import { setup as hotjarSetup } from './services/hotjar'

import Login from './containers/Login'
import Signup from './containers/Signup'
import Thanks from './containers/Thanks'
import ForgotPassword from './containers/ForgotPassword'
import ChangePassword from './containers/ChangePassword'
import SignInError from './containers/SignInError'
import Unsupported from './containers/Unsupported'

import './root.scss'

const basename = process.env.NODE_ENV === 'development' ? '/auth' : undefined

class Root extends Component {
  static propTypes = {
    data: PropTypes.object,
  }

  UNSAFE_componentWillMount() {
    hotjarSetup()
  }

  render() {
    const { data } = this.props

    return (
      <Router basename={basename}>
        <Switch>
          <Route exact path="/login" render={({ location }) => <Login location={location} data={data} />} />
          <Route path="/signup" render={({ location }) => <Signup location={location} data={data} />} />
          <Route path="/thanks" render={({ location }) => <Thanks location={location} data={data} />} />
          <Route path="/forgot" render={({ location }) => <ForgotPassword location={location} data={data} />} />
          <Route
            path="/change_password"
            render={({ location }) => <ChangePassword location={location} data={data} />}
          />
          <Route path="/sign_in_error" render={() => <SignInError data={data} />} />
          <Route path="/unsupported" render={({ location }) => <Unsupported location={location} data={data} />} />
        </Switch>
      </Router>
    )
  }
}

export default Root



// WEBPACK FOOTER //
// ./src/root.js